var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPilulasBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#00468B",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2350 4935 c-269 -54 -499 -209 -650 -438 -223 -338 -222 -777 2 -1123 41 -64 192 -221 792 -822 408 -409 777 -773 821 -808 100 -81 250 -156 380 -191 88 -23 119 -26 255 -26 136 0 167 3 255 26 691 185 986 991 577 1577 -52 76 -1468 1501 -1580 1591 -137 110 -290 183 -451 213 -100 19 -308 20 -401 1z m293 -145 c116 -14 254 -59 352 -116 69 -40 131 -97 443 -408 l362 -361 -607 -607 -608 -608 -343 343 c-189 188 -363 369 -387 403 -58 79 -109 189 -136 289 -31 113 -31 317 0 429 100 374 413 620 816 645 11 0 60 -4 108 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2405 4624 c-94 -18 -240 -91 -309 -155 -61 -56 -74 -85 -55 -121 33 -62 78 -63 151 -5 29 24 74 56 99 70 54 32 184 67 246 67 55 0 93 33 93 80 0 19 -9 40 -25 55 -28 29 -85 32 -200 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2785 4535 c-16 -15 -25 -36 -25 -55 0 -19 9 -40 25 -55 15 -16 36 -25 55 -25 19 0 40 9 55 25 16 15 25 36 25 55 0 19 -9 40 -25 55 -15 16 -36 25 -55 25 -19 0 -40 -9 -55 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265 2634 c-167 -25 -294 -63 -425 -129 -337 -170 -576 -484 -657 -865 -24 -116 -25 -363 0 -477 55 -256 168 -466 347 -643 380 -378 959 -466 1440 -219 594 305 839 1047 543 1644 -173 347 -483 586 -868 671 -69 15 -321 27 -380 18z m1215 -1234 l0 -80 -1080 0 -1080 0 0 80 0 80 1080 0 1080 0 0 -80z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilulasBlack);
export default __webpack_public_path__ + "static/media/pilulas-black.2f328c053084550827a4328ea074dbdf.svg";
export { ForwardRef as ReactComponent };